import { SharedEnvironment, TelemetryConfig } from '@raptor-fe/core';

/**
 * The web app's telemetry identity for a build environment. There is no resolveVersion: the image build does not pass
 * a release version into the bundle, so the version is reported as 'local'. Only the raptor API receives trace
 * headers; the report, federation and audit APIs do not.
 *
 * @param environment The build's environment file.
 * @returns The value for TELEMETRY_CONFIG.
 */
export function createWebTelemetryConfig(environment: SharedEnvironment): TelemetryConfig {
    return {
        roleName: 'marlin-web.app',
        serviceNamespace: 'marlin',
        serviceName: 'web',
        environment: environment.envName ?? 'local',
        correlationUrls: [environment.baseUrl],
    };
}
